import AddIcon from '@mui/icons-material/Add'
import { Alert, AlertTitle, Button, Stack } from '@mui/material'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { getContractPlan } from 'src/features/auth/getContractPlan'
import { useQueryTraceKeys } from 'src/features/traceKeys/api/useQueryTraceKeys'
import {
  getTraceKeyLimit,
  isTraceKeySupportedPlan,
} from 'src/features/traceKeys/utils/traceKeyLimit'
import {
  editorPermissions,
  hasPermission,
} from 'src/libraries/roles/permissions'
import { TraceKeysTable } from '../TraceKeysTable/TraceKeysTable'

const TRACE_KEY_HELP_PAGE_URL =
  'https://docs.channel.io/kaminashireport/ja/articles/回答検索を理解する-c64129ad'

/**
 * 検索キー一覧コンテンツコンポーネント
 * アクションボタンとテーブル表示を担当
 */
const TraceKeysContent: FC = () => {
  const { data: traceKeys = [], isLoading } = useQueryTraceKeys()
  const currentCount = traceKeys.length
  const isEditor = hasPermission(editorPermissions)

  const plan = getContractPlan()
  // このページ自体 TraceKeySupportedPlan 以外のプランでは表示されないはずだが念のため制御している
  if (!isTraceKeySupportedPlan(plan)) {
    throw new Error(`このページは${plan}プランでは利用できません`)
  }
  const limit = getTraceKeyLimit(plan)

  const isLimitReached = currentCount >= limit

  if (isLoading) {
    return
  }

  return (
    <>
      <Alert severity="info" variant="outlined" sx={{ mx: 3, mt: 2 }}>
        <AlertTitle>検索キーについて</AlertTitle>
        検索キーは、ひな形の質問に紐付けて使用します。
        <br />
        紐付けた質問の回答内容で、レポートを検索・絞り込みできるようになります。
        <br />
        詳しい使い方は
        <a
          href={TRACE_KEY_HELP_PAGE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          ヘルプページ
        </a>
        をご確認ください。
      </Alert>
      {isEditor && (
        <Stack direction="row" justifyContent="flex-end" sx={{ py: 2, px: 3 }}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            component={Link}
            to="/traceKeys/add"
            disabled={isLimitReached}
          >
            検索キーを追加 ({currentCount}/{limit})
          </Button>
        </Stack>
      )}
      <TraceKeysTable />
    </>
  )
}

export { TraceKeysContent }
